import BASE_URL from '../../utils/storage.js';

const firstErrorMessage = (value) => {
  if (typeof value === 'string') return value;
  if (Array.isArray(value)) return value.map(firstErrorMessage).filter(Boolean).join(' ');
  if (value && typeof value === 'object') {
    return Object.values(value).map(firstErrorMessage).find(Boolean) || '';
  }
  return '';
};

export const profileAPI = {
  async getProfile(authToken) {
    const response = await fetch(`${BASE_URL}profile/`, {
      method: 'GET',
      headers: {
        'Authorization': `Token ${authToken}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch profile');
    }

    return await response.json();
  },

  async updateProfile(profileData, authToken) {
    const response = await fetch(`${BASE_URL}profile/`, {
      method: 'PATCH',
      headers: {
        'Authorization': `Token ${authToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(profileData)
    });

    if (!response.ok) {
      let errorMessage = `Failed to update profile. Status: ${response.status}`;
      let errorData = null;
      try {
        errorData = await response.json();
        errorMessage = firstErrorMessage(
          errorData.detail || errorData.error || errorData.message || errorData.company || errorData,
        ) || errorMessage;
      } catch (e) {
        // If parsing JSON fails, use default message
      }
      const error = new Error(errorMessage);
      error.status = response.status;
      error.code = errorData?.code || null;
      error.raw = errorData;
      throw error;
    }

    return await response.json();
  },

  async changePassword(currentPassword, newPassword, authToken) {
    const response = await fetch(`${BASE_URL}auth/users/set_password/`, {
      method: 'POST',
      headers: {
        'Authorization': `Token ${authToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        current_password: currentPassword,
        new_password: newPassword
      })
    });

    if (response.status !== 200) {
      if (response.status === 400) {
        try {
          const errorData = await response.json();
          // Handle different error formats from djoser
          if (errorData.current_password) {
            throw new Error(errorData.current_password[0] || 'Parolă actuală incorectă');
          }
          if (errorData.new_password) {
            throw new Error(errorData.new_password[0] || 'Parolă nouă invalidă');
          }
          if (errorData.non_field_errors) {
            throw new Error(errorData.non_field_errors[0] || 'Eroare de validare');
          }
          throw new Error('Eroare la schimbarea parolei');
        } catch (e) {
          if (e.message) throw e;
          throw new Error('Parolă actuală incorectă');
        }
      }
      throw new Error(`Eroare la schimbarea parolei (Status: ${response.status})`);
    }

    const data = await response.json();
    return {
      ...data,
      reauthentication_required: data.reauthentication_required === true,
      sessions_invalidated: Number(data.sessions_invalidated || 0),
    };
  }
};
